import { createIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { messages } from '../messages';
import { type ClassificationLevel, type ClassificationOption, type Color } from './types';

const { formatMessage } = createIntl({ locale: 'en' });

export const NO_CLASSIFICATION_OPTION: ClassificationOption = {
	definition: formatMessage(messages.noClassification),
	includeIcon: false,
};

export const NO_SELECTION_OPTION: ClassificationLevel = {
	id: 'no-selection',
	name: 'No selection',
};

export const nameMaxLength = 50;
export const definitionMaxLength = 1000;
export const guidelineMaxLength = 1000;

export type ColorValues = {
	// These values are used by the dropdown component
	bgColor: string;
	fontColor: string;
	// Custom SVG icon needs to be styled with valid CSS values
	iconColor: string;
};

export type ColorsConfig = Record<Color, ColorValues>;

export type DisabledColorConfig = ColorValues;

export const colorsConfig: ColorsConfig = {
	YELLOW: {
		iconColor: token('color.icon.accent.yellow'),
		bgColor: token('color.background.accent.yellow.subtlest'),
		fontColor: token('color.text'),
	},
	ORANGE: {
		iconColor: token('color.icon.accent.orange'),
		bgColor: token('color.background.accent.orange.subtle'),
		fontColor: token('color.text'),
	},
	RED: {
		iconColor: token('color.icon.accent.red'),
		bgColor: token('color.background.accent.red.subtler'),
		fontColor: token('color.text'),
	},
	RED_BOLD: {
		iconColor: token('color.icon.inverse'),
		bgColor: token('color.background.accent.red.bolder'),
		fontColor: token('color.text.inverse'),
	},
	PURPLE: {
		iconColor: token('color.icon.accent.purple'),
		bgColor: token('color.background.accent.purple.subtlest'),
		fontColor: token('color.text'),
	},
	BLUE: {
		iconColor: token('color.icon.accent.blue'),
		bgColor: token('color.background.accent.blue.subtler'),
		fontColor: token('color.text'),
	},
	TEAL: {
		iconColor: token('color.icon.accent.teal'),
		bgColor: token('color.background.accent.teal.subtler'),
		fontColor: token('color.text'),
	},
	GREEN: {
		iconColor: token('color.icon.accent.green'),
		bgColor: token('color.background.accent.green.subtlest'),
		fontColor: token('color.text'),
	},
	GREY: {
		iconColor: token('color.icon.accent.gray'),
		bgColor: token('color.background.accent.gray.subtlest'),
		fontColor: token('color.text'),
	},
	LIME: {
		iconColor: token('color.icon.accent.lime'),
		bgColor: token('color.background.accent.lime.subtler'),
		fontColor: token('color.text'),
	},
};

// Doesn't exist within `colorsConfig` since it's not a valid `Color` type
export const disabledColorConfig: DisabledColorConfig = {
	iconColor: token('color.icon.disabled'),
	bgColor: token('color.background.disabled'),
	fontColor: token('color.text.disabled'),
};
